export const isMarketOpen = () => {
  const now = new Date();
  
  // Convert to Eastern Time
  const easternTime = new Date(now.toLocaleString("en-US", {timeZone: "America/New_York"}));
  
  const day = easternTime.getDay();
  const hour = easternTime.getHours();
  const minute = easternTime.getMinutes();
  
  // Check if it's a weekday (Mon=1 to Fri=5)
  if (day === 0 || day === 6) {
    return false;
  }
  
  // Convert time to minutes from midnight for easier comparison
  const minutesFromMidnight = hour * 60 + minute;
  
  // Market hours: 9:30 AM to 4:00 PM ET
  // 9:30 AM = 9 * 60 + 30 = 570
  // 4:00 PM = 16 * 60 = 960
  
  return minutesFromMidnight >= 570 && minutesFromMidnight < 960;
};
